import { vendorSecretBaseModel } from './crud';

export * from './types';

export const useVendorSecretsById = vendorSecretBaseModel.fetchById();
export const useVendorSecretsByIds = vendorSecretBaseModel.fetchByIds();
export const useVendorSecretsMany = vendorSecretBaseModel.fetchMany();
export const useVendorSecretsCount = vendorSecretBaseModel.count();
export const useVendorSecretsManyInfiniteQuery =
  vendorSecretBaseModel.fetchPaginated();
export const useVendorSecretsUpdateOne = vendorSecretBaseModel.edit();
export const useVendorSecretsCreateOne = vendorSecretBaseModel.create();
export const useVendorSecretsRemoveOne = vendorSecretBaseModel.delete();
export const useVendorSecretsRemoveByIds = vendorSecretBaseModel.deleteByIds();

export const useVendorSecretsByIdV2 = vendorSecretBaseModel.fetchByIdV2();
export const useVendorSecretsByIdsV2 = vendorSecretBaseModel.fetchByIdsV2();
export const useVendorSecretsManyV2 = vendorSecretBaseModel.fetchManyV2();
export const useVendorSecretsCountV2 = vendorSecretBaseModel.countV2();
export const useVendorSecretsManyInfiniteQueryV2 =
  vendorSecretBaseModel.fetchPaginatedV2();
export const useVendorSecretsUpdateOneV2 = vendorSecretBaseModel.editV2();
export const useVendorSecretsCreateOneV2 = vendorSecretBaseModel.createV2();
export const useVendorSecretsRemoveOneV2 = vendorSecretBaseModel.deleteV2();
export const useVendorSecretsRemoveByIdsV2 =
  vendorSecretBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useVendorSecretById = vendorSecretBaseModel.fetchById();
export const useVendorSecretByIds = vendorSecretBaseModel.fetchByIds();
export const useVendorSecretMany = vendorSecretBaseModel.fetchMany();
export const useVendorSecretCount = vendorSecretBaseModel.count();
export const useVendorSecretPagination = vendorSecretBaseModel.fetchPaginated();
export const useVendorSecretUpdateOne = vendorSecretBaseModel.edit();
export const useVendorSecretCreateOne = vendorSecretBaseModel.create();
export const useVendorSecretRemoveOne = vendorSecretBaseModel.delete();
export const useVendorSecretRemoveByIds = vendorSecretBaseModel.deleteByIds();

export const useVendorSecretByIdV2 = vendorSecretBaseModel.fetchByIdV2();
export const useVendorSecretByIdsV2 = vendorSecretBaseModel.fetchByIdsV2();
export const useVendorSecretManyV2 = vendorSecretBaseModel.fetchManyV2();
export const useVendorSecretCountV2 = vendorSecretBaseModel.countV2();
export const useVendorSecretPaginationV2 =
  vendorSecretBaseModel.fetchPaginatedV2();
export const useVendorSecretUpdateOneV2 = vendorSecretBaseModel.editV2();
export const useVendorSecretCreateOneV2 = vendorSecretBaseModel.createV2();
export const useVendorSecretRemoveOneV2 = vendorSecretBaseModel.deleteV2();
export const useVendorSecretRemoveByIdsV2 =
  vendorSecretBaseModel.deleteByIdsV2();
